import axios from 'axios'
import React, { useContext, useEffect, useState } from 'react'
import { ConfigContext } from '../Context/ConfigContext'
import Categories from './Categories'
import Offers from './Offers'
import PopularProducts from './PopularProducts'
import Trending from './Trending'

const HeroSlider = () => {

    const { apiURL } = useContext(ConfigContext)
    const [data, setData] = useState([])

    const GetSlider = async () => {
        const response = await axios.get(`${apiURL}Home/GetHomeSlider`)
        setData(response.data.data);
    }

    useEffect(() => {
        GetSlider()
        document.title = 'StoneSkills'
    }, [])


    return (
        <>
            <main className='main'>
                <section className="home-slider position-relative mb-30">
                    <div className="container">
                        <div className="home-slide-cover mt-30">
                            <div className="hero-slider-1 style-4 dot-style-1 dot-style-1-position-1">
                                {
                                    data.map((item) => {
                                        return (
                                            <div key={item.slider_id} className="single-hero-slider single-animation-wrap" style={{ backgroundImage: `url(${item.slider_image_url})` }}>
                                                <div className="slider-content">
                                                    <h1 className="display-2 mb-40 text-white">
                                                        {item.slider_title}
                                                    </h1>
                                                    <p className="mb-65 text-white">{item.slider_description}</p>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div className="slider-arrow hero-slider-1-arrow" />
                        </div>
                    </div>
                </section>

                {/* <Categories /> */}
                <Offers />
                <PopularProducts />
                <Trending />
            </main>
        </>
    )
}

export default HeroSlider